// @ts-nocheck
/* Port of FilterChips.js (28L). BYTE-IDENTICAL. */
import React from 'react';
import { FILTER_CHIPS } from './releaseUtils';

const FilterChips = ({ active, onChange }: any) => (
  <div className="rc-chips" role="tablist" aria-label="Filter releases">
    {FILTER_CHIPS.map((chip: any) => {
      const isActive =
        (chip.kind === 'all' && !active) || active?.key === chip.key;
      return (
        <button
          key={chip.key}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`rc-chip ${isActive ? 'rc-chip--active' : ''}`}
          onClick={() => onChange(chip.kind === 'all' ? null : chip)}
        >
          {isActive && chip.kind !== 'all' && (
            <span className="rc-chip__check" aria-hidden="true">
              ✓
            </span>
          )}
          {chip.label}
        </button>
      );
    })}
  </div>
);

export default FilterChips;
